import PeriodSwitcher from './PeriodSwitcher';

export default PeriodSwitcher;
